/** Direct swipe/drag for Cause cards + 2+ photo carousels. Per-root only. */
(function () {
  "use strict";
  var TH = 36;
  var RATIO = 1.25;
  var SKIP = "a,button,input,select,textarea,label,video,audio,iframe,[role='button'],[role='tab'],[role='link']";
  var INNER = ".mayekoo-updates-v2__carousel,.mayekoo-updates-v2__embed,iframe";
  var FEED = '[data-mayekoo-updates-v2="feed"]';

  if (!document.getElementById("mk-swipe-css")) {
    var css = document.createElement("style");
    css.id = "mk-swipe-css";
    css.textContent = "[data-cards],.mayekoo-updates-v2__carousel{touch-action:pan-y}.is-mk-drag,.is-mk-drag *{-webkit-user-select:none;user-select:none}";
    document.head.appendChild(css);
  }

  function bind(root, opts) {
    if (root.dataset.mkSwipe === "1") return;
    root.dataset.mkSwipe = "1";
    var sx = 0, sy = 0, armed = false, dragged = false, pid = null;

    function start(x, y, target, id) {
      if (!target || target.closest(SKIP)) return false;
      if (opts.ignore && target.closest(opts.ignore)) return false;
      if (opts.active && !opts.active()) return false;
      sx = x; sy = y; armed = true; dragged = false; pid = id;
      return true;
    }
    function move(x, y, event) {
      if (!armed) return;
      var dx = x - sx, dy = y - sy;
      if (!dragged) {
        if (Math.abs(dx) < TH || Math.abs(dx) < RATIO * Math.abs(dy)) return;
        dragged = true;
        root.classList.add("is-mk-drag");
      }
      if (event.cancelable) event.preventDefault();
    }
    function finish(x) {
      if (!armed) return;
      armed = false;
      root.classList.remove("is-mk-drag");
      if (!dragged) return;
      var dx = x - sx;
      if (dx < 0) opts.next();
      else if (dx > 0) opts.prev();
      function swallow(event) {
        event.preventDefault();
        event.stopPropagation();
        root.removeEventListener("click", swallow, true);
      }
      root.addEventListener("click", swallow, true);
      setTimeout(function () { root.removeEventListener("click", swallow, true); }, 400);
    }

    root.addEventListener("pointerdown", function (event) {
      if (event.pointerType === "mouse" && event.button !== 0) return;
      if (start(event.clientX, event.clientY, event.target, event.pointerId)) {
        try { root.setPointerCapture(event.pointerId); } catch (_err) {}
      }
    });
    root.addEventListener("pointermove", function (event) {
      if (!armed || event.pointerId !== pid) return;
      move(event.clientX, event.clientY, event);
    }, { passive: false });
    function stop(event) {
      if (!armed || (event.pointerId != null && event.pointerId !== pid)) return;
      finish(event.clientX);
      pid = null;
    }
    root.addEventListener("pointerup", stop);
    root.addEventListener("pointercancel", function () {
      armed = false;
      dragged = false;
      pid = null;
      root.classList.remove("is-mk-drag");
    });
  }

  function clickNav(shell, sel) {
    var btn = shell && shell.querySelector(sel);
    if (btn && !btn.disabled) btn.click();
  }

  function initOuter(list) {
    if (list.closest("[data-journal]")) return;
    var shell = list.closest(".mayekoo-updates-v2__cards-shell") || list.parentElement;
    bind(list, {
      ignore: INNER,
      active: function () {
        var wrap = list.closest(".mayekoo-updates-v2__cards-shell");
        return !!(wrap && wrap.classList.contains("is-paged"));
      },
      next: function () { clickNav(shell, ".mayekoo-updates-v2__cards-next"); },
      prev: function () { clickNav(shell, ".mayekoo-updates-v2__cards-prev"); }
    });
  }

  function initInner(carousel) {
    bind(carousel, {
      next: function () { clickNav(carousel, '.mayekoo-updates-v2__arrow[data-dir="1"]'); },
      prev: function () { clickNav(carousel, '.mayekoo-updates-v2__arrow[data-dir="-1"]'); }
    });
  }

  function scan(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-cards]").forEach(initOuter);
    root.querySelectorAll(".mayekoo-updates-v2__carousel").forEach(initInner);
  }

  function watch() {
    document.querySelectorAll(FEED).forEach(function (feed) {
      if (feed.dataset.mkSwipeWatch === "1") return;
      feed.dataset.mkSwipeWatch = "1";
      var obs = new MutationObserver(function () { scan(feed); });
      obs.observe(feed, { childList: true, subtree: true });
      scan(feed);
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", watch);
  else watch();
  document.addEventListener("shopify:section:load", watch);
})();
